import {
  GET_ADMIN_FILTER_PACKAGES,
  GET_ADMIN_FILTER_PACKAGES_SUCCESS,
  GET_ADMIN_FILTER_PACKAGES_ERROR,
  POST_ADMIN_FILTER_PACKAGES,
  POST_ADMIN_FILTER_PACKAGES_SUCCESS,
  POST_ADMIN_FILTER_PACKAGES_ERROR,
  UPDATE_ADMIN_FILTER_PACKAGES,
  UPDATE_ADMIN_FILTER_PACKAGES_SUCCESS,
  UPDATE_ADMIN_FILTER_PACKAGES_ERROR,
  DELETE_ADMIN_FILTER_PACKAGES,
  DELETE_ADMIN_FILTER_PACKAGES_SUCCESS,
  DELETE_ADMIN_FILTER_PACKAGES_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  error: null,
  loading: false,
  admin_filter_packages: [],
}
const AdminFilterPackages = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADMIN_FILTER_PACKAGES:
      return {
        ...state,
        error: null,
        loading: true
      }

    case GET_ADMIN_FILTER_PACKAGES_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        admin_filter_packages: action.payload
      }

    case GET_ADMIN_FILTER_PACKAGES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case POST_ADMIN_FILTER_PACKAGES:
      return {
        ...state,
        error: null,
        loading: true
      }

    case POST_ADMIN_FILTER_PACKAGES_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        admin_filter_packages: [...state.admin_filter_packages, action.payload]
      }

    case POST_ADMIN_FILTER_PACKAGES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case UPDATE_ADMIN_FILTER_PACKAGES:
      return {
        ...state,
        error: null,
        loading: true
      }

    case UPDATE_ADMIN_FILTER_PACKAGES_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        admin_filter_packages: state.admin_filter_packages.map(item => item.id === action.payload.id ? action.payload : item)
      }

    case UPDATE_ADMIN_FILTER_PACKAGES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case DELETE_ADMIN_FILTER_PACKAGES:
      return {
        ...state,
        error: null,
        loading: true
      }

    case DELETE_ADMIN_FILTER_PACKAGES_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        admin_filter_packages: state.admin_filter_packages.filter(item => item.id !== action.payload.id)
      }

    case DELETE_ADMIN_FILTER_PACKAGES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}

export default AdminFilterPackages;
